import {scriptonload} from '../modules/scriptonload';

var cityMap = function(wrapper, param, callback){
	var param = param ? param : JSON.parse(wrapper.getAttribute('data-param')),
		MyMap = class {
			constructor(wrapper){
				this.wrapper = wrapper;
				this._createElements();
			}

			_createElements(){
				this.MyMap = this._createMyMap();
			}

			_createMyMap(){
				var MyMap = new ymaps.Map(this.wrapper, {
						center: param.map.center,
						zoom: param.map.zoom,
						controls: ["zoomControl"],
						behaviors: ['default', 'scrollZoom']
					}, {
						searchControlProvider: 'yandex#search'
					}),
					myCollection = new ymaps.GeoObjectCollection();

				//
				MyMap.behaviors.disable(['scrollZoom']);

				for(var name in param.cities){
					var city = param.cities[name],
						myPlacemark = new ymaps.Placemark([city.lat, city.lon], {
							hintContent: city.name
						}, {
							iconLayout: 'default#image',
							iconImageHref: '/static/img/symbols/map-icon.png',
							iconImageSize: [16, 16],
							iconImageOffset: [-8, -8]
						});

					//
					myPlacemark.events.add(['click'], (function (city) {
						return function(){
							window.location.assign(city.link);
						}
					})(city));
					myCollection.add(myPlacemark);
				}

				MyMap.geoObjects.add(myCollection);
				return MyMap;
			}
		};

	//
	scriptonload(['https://api-maps.yandex.ru/2.1/?lang=ru_RU', '//yandex.st/jquery/2.0.3/jquery.min.js'], function(){
		ymaps.load([], function(){
			var map = new MyMap(wrapper);
			if(callback) callback(map);
		});
	});
};

export {cityMap};